import React, { useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './SuperMarket.css';

function SuperMarket() {
  const [categories] = useState({
    
      "General": [
        { "name": "Rice", "price": 50 },
        { "name": "Salt", "price": 20 },
        { "name": "Wheat Flour", "price": 40 },
        { "name": "Sugar", "price": 35 },
        { "name": "Pasta", "price": 60 },
        { "name": "Oats", "price": 80 },
        { "name": "Cornflakes", "price": 100 },
        { "name": "Bread", "price": 30 },
        { "name": "Butter", "price": 45 },
        { "name": "Cheese", "price": 90 },
        { "name": "Eggs", "price": 60 },
        { "name": "Milk", "price": 50 },
        { "name": "Curd", "price": 30 },
        { "name": "Paneer", "price": 120 },
        { "name": "Yogurt", "price": 40 },
        { "name": "Tofu", "price": 70 },
        { "name": "Chicken", "price": 200 },
        { "name": "Fish", "price": 250 },
        { "name": "Prawns", "price": 300 },
        { "name": "Mutton", "price": 350 },
        { "name": "Beef", "price": 400 },
        { "name": "Pork", "price": 350 },
        { "name": "Bacon", "price": 300 },
        { "name": "Sausage", "price": 200 },
        { "name": "Ham", "price": 250 },
        { "name": "Nuts", "price": 200 },
        { "name": "Almonds", "price": 300 },
        { "name": "Cashews", "price": 250 },
        { "name": "Walnuts", "price": 350 },
        { "name": "Peanuts", "price": 100 },
        { "name": "Raisins", "price": 150 },
        { "name": "Dates", "price": 200 },
        { "name": "Figs", "price": 250 },
        { "name": "Chia Seeds", "price": 300 },
        { "name": "Flax Seeds", "price": 200 },
        { "name": "Sunflower Seeds", "price": 150 },
        { "name": "Pumpkin Seeds", "price": 200 },
        { "name": "Sesame Seeds", "price": 100 },
        { "name": "Basil", "price": 50 },
        { "name": "Mint", "price": 40 },
        { "name": "Coriander", "price": 30 },
        { "name": "Parsley", "price": 50 },
        { "name": "Dill", "price": 30 },
        { "name": "Thyme", "price": 40 },
        { "name": "Rosemary", "price": 50 },
        { "name": "Oregano", "price": 50 },
        { "name": "Basil Leaves", "price": 50 },
        { "name": "Pasta Sauce", "price": 80 },
        { "name": "Ketchup", "price": 40 },
        { "name": "Mayonnaise", "price": 60 },
        { "name": "Mustard", "price": 40 },
        { "name": "Hot Sauce", "price": 50 },
        { "name": "Soy Sauce", "price": 60 },
        { "name": "Vinegar", "price": 30 },
        { "name": "Olives", "price": 100 },
        { "name": "Pickles", "price": 50 },
        { "name": "Cornflour", "price": 40 },
        { "name": "Coconut Milk", "price": 70 },
        { "name": "Baking Powder", "price": 30 },
        { "name": "Baking Soda", "price": 20 },
        { "name": "Custard Powder", "price": 50 },
        { "name": "Gelatin", "price": 40 },
        { "name": "Yeast", "price": 60 },
        { "name": "Jaggery", "price": 30 },
        { "name": "Saffron", "price": 300 },
        { "name": "Cardamom", "price": 250 },
        { "name": "Nutmeg", "price": 200 },
        { "name": "Cloves", "price": 150 },
        { "name": "Vanilla Extract", "price": 100 },
        { "name": "Rose Water", "price": 60 },
        { "name": "Asofoditia", "price": 60 },
      
  { "name": "Dil seeds", "price": 120 },
  { "name": "Sunflower seeds", "price": 95 },
  { "name": "Pumpkin seeds", "price": 150 },
  { "name": "Chia seeds", "price": 200 },
  { "name": "Flax seeds", "price": 130 },
  { "name": "Sesame seeds", "price": 90 },
  { "name": "Watermelon seeds", "price": 110 },
  { "name": "Mustard seeds", "price": 80 },
  { "name": "Nigella seeds", "price": 100 },
  { "name": "Basil seeds", "price": 140 },
  { "name": "Hemp seeds", "price": 170 },
  { "name": "Poppy seeds", "price": 160 },
  { "name": "Quinoa seeds", "price": 210 },
  { "name": "Fenugreek seeds", "price": 75 },
  { "name": "Ajwain seeds", "price": 85 },

  
  { "name": "Curry leaves", "price": 20 },
  { "name": "Spinach", "price": 25 },
  { "name": "Fenugreek leaves", "price": 30 },
  { "name": "Mint leaves", "price": 15 },
  { "name": "Coriander leaves", "price": 10 },
  { "name": "Drumsticks", "price": 45 },
  { "name": "Ridge gourd", "price": 35 },
  { "name": "Bottle gourd", "price": 40 },
  { "name": "Bitter gourd", "price": 38 },
  { "name": "Snake gourd", "price": 42 },
  { "name": "Brinjal", "price": 28 },
  { "name": "Lady’s finger", "price": 32 },
  { "name": "Tomato", "price": 20 },
  { "name": "Green chili", "price": 18 },
  { "name": "Capsicum", "price": 50 },
  { "name": "Cabbage", "price": 22 },
  { "name": "Cauliflower", "price": 55 },
  { "name": "Carrot", "price": 30 },
  { "name": "Beetroot", "price": 34 },
  { "name": "Radish", "price": 25 },
  { "name": "Onion", "price": 24 },
  { "name": "Potato", "price": 26 },
  { "name": "Green peas", "price": 60 },
  { "name": "Cluster beans", "price": 36 },
  { "name": "Taro root", "price": 48 },

        
  { "name": "other Powder", "price": 55 },
  { "name": "Millets", "price": 120 },
  { "name": "Other millets", "price": 300 },
  { "name": "Ginger Garlic Paste", "price": 50 },
  { "name": "Foxtail Millet", "price": 60 },
  { "name": "Barnyard Millet", "price": 55 },
  { "name": "Little Millet", "price": 50 },
  { "name": "Kodo Millet", "price": 52 },
  { "name": "Bajra (Pearl Millet)", "price": 40 },
  { "name": "Jowar (Sorghum)", "price": 35 },
  { "name": "Ragi (Finger Millet)", "price": 38 },
   { "name": "Plastic mugs", "price": 25 },
  { "name": "Plastic jugs", "price": 20 },
  { "name": "Plastic items", "price": 35 },
   { "name": "Zandu balm", "price": 40 },
  { "name": "Amurthanjan", "price": 40 },
   { "name": "Perfume", "price": 225 },
  { "name": "stay free", "price": 40 },
  { "name": "baby soap", "price": 35 },
   { "name": "Diapher", "price": 20 },
  { "name": "Tissues", "price": 35 },
   { "name": "Ponds", "price": 75 },
  { "name": "face Powder", "price": 120 },
  { "name": "face cream", "price": 135 },
   { "name": "Hand wash", "price": 120 },
  { "name": "face wash", "price": 135 },
   { "name": "Clothes", "price": 425 },
  { "name": "shoes", "price": 520 },
  { "name": "Sacks", "price": 135 },
   { "name": "Sandals/ Chappals", "price": 620 },
  { "name": "Dressing material", "price": 335 },
   { "name": "Dry items", "price": 525 },
  { "name": "French fries", "price": 120 },
  { "name": "Packed items", "price": 35 },
   { "name": "Steel bowls", "price": 20 },
  { "name": "steel items", "price": 65 },
   { "name": "Gift sets", "price": 1025 },
  { "name": "Glass sets", "price": 520 },
  { "name": "School bags", "price": 635 },
   { "name": "Casual bags", "price": 990 },
  { "name": "Trolly  bags", "price": 2105 },
   { "name": "Cooker", "price": 825 },
  { "name": "Electrical item", "price": 320 },
  { "name": "Helmets", "price": 935 },
   { "name": "Rain coats", "price": 720 },
  { "name": "Comfort", "price": 35 },
   { "name": "Rin powder", "price": 25 },
  { "name": "Bulbs", "price": 50 },
  { "name": "water bottle", "price": 20 },
   { "name": "Soft drink", "price": 20 },
  { "name": "Chips/ Kurkure", "price": 35 },
   { "name": "Tube lights", "price": 125 },
  { "name": "Coconuts", "price": 40 },
  { "name": "betel leaves", "price": 3 },
   { "name": "betel nuts", "price": 50 },
  { "name": "Wall clock", "price": 35 },
  
  { "name": "Colgate", "price": 65 },
  { "name": "Pepsodent", "price": 60 },
  { "name": "Sensodyne", "price": 140 },
  { "name": "Closeup", "price": 75 },
  { "name": "Dabur Red", "price": 55 },
  { "name": "Patanjali Dant Kanti", "price": 50 },
  { "name": "Himalaya Herbals", "price": 90 },
  { "name": "Oral-B", "price": 85 },
  { "name": "Babool", "price": 45 },
  { "name": "Meswak", "price": 60 },
  { "name": "Bentodent", "price": 100 },
  { "name": "Jagat Devsutra", "price": 80 },
  { "name": "Maharishi Ayurveda Ayurdent", "price": 95 },
  { "name": "ENAFIX", "price": 110 },
  { "name": "Zandu Dantveer", "price": 70 },
  { "name": "Mamaearth", "price": 120 },
  { "name": "Perfora", "price": 130 },
  { "name": "Parodontax", "price": 125 },
  { "name": "Chicco", "price": 95 },
  { "name": "Vantej", "price": 115 },

  
  { "name": "Dove", "price": 75 },
  { "name": "Pears", "price": 65 },
  { "name": "Lux", "price": 40 },
  { "name": "Lifebuoy", "price": 35 },
  { "name": "Cinthol", "price": 45 },
  { "name": "Fiama", "price": 60 },
  { "name": "Dettol", "price": 50 },
  { "name": "Santoor", "price": 38 },
  { "name": "Mysore Sandal", "price": 80 },
  { "name": "Godrej No.1", "price": 30 },
  { "name": "Biotique", "price": 90 },
  { "name": "Khadi Natural", "price": 85 },
  { "name": "Mamaearth", "price": 110 },
  { "name": "Medimix", "price": 55 },
  { "name": "Park Avenue", "price": 70 },
  { "name": "Ayush", "price": 40 },
  { "name": "Himalaya Herbals", "price": 60 },
  { "name": "Dabur Gulabari", "price": 50 },
  { "name": "Zest", "price": 35 },
  { "name": "Wild Stone", "price": 65 },

  
  { "name": "Savlon", "price": 55 },
  { "name": "Liril", "price": 45 },
  { "name": "Rexona", "price": 40 },
  { "name": "Vivel", "price": 50 },
  { "name": "Godrej FairGlow", "price": 35 },
  { "name": "Cetaphil Cleansing Bar", "price": 120 },
  { "name": "Kozicare Kojic Acid", "price": 95 },
  { "name": "Ustraa Charcoal Deo Soap", "price": 90 },
  { "name": "Mirah Belle Goat Milk", "price": 105 },
  { "name": "Lucacci Whitening", "price": 92 },



  { "name": "Iodized Table Salt", "price": 25 },
  { "name": "Himalayan Pink Salt", "price": 85 },
  { "name": "Black Salt (Kala Namak)", "price": 60 },
  { "name": "Rock Salt (Sendha Namak)", "price": 50 },
  { "name": "Sea Salt", "price": 70 },
  { "name": "Raw Salt", "price": 70 },
  { "name": "Table Salt", "price": 50 },



  { "name": "Cetaphil", "price": 377 },
  { "name": "Himalaya Neem", "price": 140 },
  { "name": "Mamaearth Ubtan", "price": 210 },
  { "name": "Pond's Bright Beauty", "price": 226 },
  { "name": "Garnier Men Acno Fight", "price": 194 },
  { "name": "Minimalist Salicylic Acid", "price": 299 },
  { "name": "Muuchstac Ocean", "price": 245 },
  { "name": "Lakmé Vitamin C", "price": 185 },
  { "name": "WOW Apple Cider Vinegar", "price": 210 },
  { "name": "Clean & Clear Foaming", "price": 120 },



  { "name": "Fogg", "price": 299 },
  { "name": "Denver", "price": 349 },
  { "name": "Wild Stone", "price": 298 },
  { "name": "Park Avenue", "price": 328 },
  { "name": "Skinn by Titan", "price": 479 },
  { "name": "Bella Vita Luxury", "price": 499 },
  { "name": "Beardo", "price": 420 },
  { "name": "Villain", "price": 399 },
  { "name": "Axe Signature", "price": 289 },
  { "name": "Yardley", "price": 375 },


  { "name": "L'Oréal Paris", "price": 275 },
  { "name": "Dove", "price": 643 },
  { "name": "TRESemme", "price": 630 },
  { "name": "Pantene", "price": 285 },
  { "name": "Head & Shoulders", "price": 295 },
  { "name": "Himalaya Herbals", "price": 231 },
  { "name": "Mamaearth", "price": 649 },
  { "name": "Clinic Plus", "price": 125 },
  { "name": "Biotique", "price": 90 },
  { "name": "Patanjali", "price": 75 },



  { "name": "Diamond Sugar Candy", "price": 60 },
  { "name": "Normal Sugar Candy", "price": 40 },
  { "name": "Rock Sugar (Mishri)", "price": 55 },
  { "name": "Thread Sugar Candy (Sita Ram Candy)", "price": 65 },
  { "name": "Colored Sugar Candy", "price": 50 },
  { "name": "Pan Pasand Candy", "price": 10 },
  { "name": "Pulse Candy", "price": 5 },
  { "name": "Kesar Mishri", "price": 70 },
  { "name": "Fruit Flavored Sugar Candy", "price": 45 },
  { "name": "Crystal Sugar Candy", "price": 58 },


  
  { "name": "L'Oréal Paris Excellence Creme Hair Color", "price": 590 },
  { "name": "Garnier Color Naturals", "price": 175 },
  { "name": "Godrej Expert Rich Creme", "price": 155 },
  { "name": "Streax Cream Hair Color", "price": 125 },
  { "name": "Revlon Colorsilk Hair Color", "price": 435 },
  { "name": "BBlunt Salon Secret Hair Color", "price": 193 },
  { "name": "Indus Valley Organic Hair Color", "price": 575 },
  { "name": "Biotique Herbcolor Hair Dye", "price": 299 },
  { "name": "Matrix SoColor Professional Hair Color", "price": 320 },
  { "name": "Schwarzkopf Igora Royal Hair Color", "price": 550 },
  { "name": "Beardo Beard Color – Natural Black", "price": 360 },
  { "name": "Bigen Men's Beard Color", "price": 400 },
  { "name": "Urbangabru Beard Color with Henna", "price": 379 },
  { "name": "Bombay Shaving Company Beard Color", "price": 248 },
  { "name": "Paradyes Hair & Beard Tint", "price": 275 },




  { "name": "Lakmé 9 to 5 Lipstick", "price": 499 },
  { "name": "Maybelline Superstay Matte Ink", "price": 599 },
  { "name": "L'Oréal Paris Rouge Signature", "price": 699 },
  { "name": "Sugar Smudge Me Not Liquid Lipstick", "price": 499 },
  { "name": "MAC Retro Matte Lipstick", "price": 1800 },
  { "name": "Mamaearth Ubtan Face Cream", "price": 399 },
  { "name": "Pond's Bright Beauty Cream", "price": 225 },
  { "name": "Olay Total Effects 7-in-1 Cream", "price": 849 },
  { "name": "Nivea Soft Moisturizer", "price": 313 },
  { "name": "Biotique Bio Morning Nectar Cream", "price": 280 },
  { "name": "Himalaya Clear Complexion Cream", "price": 250 },
  { "name": "Lotus Herbals WhiteGlow Cream", "price": 355 },
  { "name": "Garnier Light Complete Serum Cream", "price": 131 },
  { "name": "Cetaphil Moisturizing Lotion", "price": 486 },
  { "name": "Plum Green Tea Mattifying Moisturizer", "price": 475 },
  { "name": "Minimalist Vitamin B5 Gel", "price": 399 },
  { "name": "Mamaearth Vitamin C Face Wash", "price": 249 },
  { "name": "WOW Skin Science Aloe Vera Gel", "price": 299 },
  { "name": "Dot & Key Vitamin C Serum", "price": 595 },
  { "name": "Kama Ayurveda Kumkumadi Oil", "price": 2995 },
  { "name": "Nykaa So Matte Lipstick", "price": 399 },
  { "name": "Renee Fab 5-in-1 Lipstick", "price": 750 },
  { "name": "Faces Canada Ultime Pro Lip Crayon", "price": 799 },
  { "name": "MyGlamm LIT Liquid Matte Lipstick", "price": 395 },
  { "name": "Swiss Beauty Pure Matte Lipstick", "price": 229 },



  { "name": "Scissors", "price": 45 },
  { "name": "Comb", "price": 25 },
  { "name": "Nail Cutter", "price": 30 },
  { "name": "Shoe Polish", "price": 40 },
  { "name": "Laundry Sack", "price": 60 },
  { "name": "Toothbrush", "price": 20 },
  { "name": "Hair Brush", "price": 85 },
  { "name": "Shaving Cream", "price": 75 },
  { "name": "Manual Shaver", "price": 90 },
  { "name": "Electric Trimmer", "price": 799 },
  { "name": "Headset", "price": 699 },
  { "name": "Earphones", "price": 299 },
  { "name": "Hand Mirror", "price": 35 },
  { "name": "Face Towel", "price": 55 },
  { "name": "Pocket Perfume", "price": 120 },
  { "name": "Lip Balm", "price": 99 },
  { "name": "Hair Gel", "price": 110 },
  { "name": "Deodorant Spray", "price": 150 },
  { "name": "Safety Pins", "price": 20 },
  { "name": "Cotton Swabs", "price": 25 },
  { "name": "Makeup Sponge", "price": 60 },
  { "name": "Tweezers", "price": 40 },
  { "name": "Hand Sanitizer", "price": 65 },
  { "name": "Face Mask (Reusable)", "price": 50 },
  { "name": "Pocket Comb Set", "price": 35 },
  { "name": "Hair Clipper", "price": 950 },
  { "name": "Shoe Brush", "price": 30 },
  { "name": "Laundry Bag", "price": 70 },
  { "name": "Travel Pouch", "price": 120 },
  { "name": "Keychain", "price": 25 },


  
  { "name": "Sona Masuri Rice", "price": 65 },
  { "name": "Basmati Rice", "price": 120 },
  { "name": "Kolam Rice", "price": 55 },
  { "name": "Indrayani Rice", "price": 70 },
  { "name": "Gobindobhog Rice", "price": 90 },
  { "name": "Jeerakasala Rice", "price": 85 },
  { "name": "Ponni Rice", "price": 60 },
  { "name": "Matta Rice", "price": 75 },
  { "name": "Dubraj Rice", "price": 68 },
  { "name": "Rajamudi Rice", "price": 80 },
  { "name": "Ambemohar Rice", "price": 95 },
  { "name": "Mogra Rice", "price": 58 },
  { "name": "Miniket Rice", "price": 62 },
  { "name": "Sharbati Rice", "price": 88 },
  { "name": "Sugandha Rice", "price": 92 },
  { "name": "Wada Kolam Rice", "price": 78 },
  { "name": "Black Rice", "price": 110 },
  { "name": "Red Rice", "price": 100 },
  { "name": "Bamboo Rice", "price": 120 },
  { "name": "Patna Rice", "price": 65 },


  { "name": "Uppidi Beyam", "price": 60 },
  { "name": "Dampedu Beyam/ unpolished Rice", "price": 65 },
  { "name": "Molakolukulu Rice", "price": 70 },
  { "name": "Biyyam Samba", "price": 68 },
  { "name": "Kurnool Sona Rice", "price": 72 },
  { "name": "Nellore Masuri Rice", "price": 75 },
  { "name": "Kaveri Beyam", "price": 66 },
  { "name": "Chitti Mutyalu Rice", "price": 85 },
  { "name": "Samba Masuri Rice", "price": 78 },
  { "name": "Kagga Rice", "price": 80 },
  { "name": "Kalanamak Rice", "price": 90 },
  { "name": "Mappillai Samba Rice", "price": 88 },


      ],
    
    
    
      
        "Dal": [
          { "name": "Toor Dal", "price": 70 },
          { "name": "Moong Dal", "price": 60 },
          { "name": "Urad Dal", "price": 80 },
          { "name": "Chana Dal", "price": 50 },
          { "name": "Masoor Dal", "price": 65 },
          { "name": "Arhar Dal", "price": 75 },
          { "name": "Kabuli Chana", "price": 100 },
          { "name": "Kala Chana", "price": 55 },
          { "name": "Rajma", "price": 90 },
          { "name": "Lobia", "price": 70 },
          { "name": "Moth Beans", "price": 60 },
          { "name": "Horse Gram", "price": 50 },
          { "name": "Green Gram", "price": 65 },
          { "name": "Black Gram", "price": 80 },
          { "name": "Yellow Moong Dal", "price": 60 },
          { "name": "Split Green Moong Dal", "price": 65 },
          { "name": "Split Urad Dal", "price": 80 },
          { "name": "Split Chana Dal", "price": 55 },
          { "name": "Whole Masoor Dal", "price": 70 },
          { "name": "Whole Toor Dal", "price": 75 },
          { "name": "White Peas", "price": 45 },
          { "name": "Green Peas", "price": 50 },
          { "name": "Brown Lentils", "price": 60 },
          { "name": "Red Lentils", "price": 65 },
          { "name": "Black Eyed Peas", "price": 70 },
          { "name": "Pigeon Peas", "price": 80 },
          { "name": "Adzuki Beans", "price": 90 },
          { "name": "Black Beans", "price": 100 },
          { "name": "Cannellini Beans", "price": 110 },
          { "name": "Navy Beans", "price": 105 },
          { "name": "Pinto Beans", "price": 95 },
          { "name": "Kidney Beans", "price": 85 },
          { "name": "Red Chori", "price": 75 },
          { "name": "Soybeans", "price": 80 },
          { "name": "Broad Beans", "price": 70 },
          { "name": "Lima Beans", "price": 85 },
          { "name": "Mung Beans", "price": 60 },
          { "name": "Matki", "price": 55 },
          { "name": "Mung Dal Chilka", "price": 65 },
          { "name": "Mung Dal Split", "price": 60 },
          { "name": "Chawli", "price": 50 },
          { "name": "Masoor Malka", "price": 70 },
          { "name": "Whole Moong", "price": 65 },
          { "name": "Whole Urad", "price": 80 },
          { "name": "Split Toor", "price": 75 },
          { "name": "Split Masoor", "price": 70 },
          { "name": "Green Lentils", "price": 75 },
          { "name": "Yellow Split Peas", "price": 55 },
          { "name": "Green Split Peas", "price": 60 },
          { "name": "Fava Beans", "price": 100 },
          { "name": "Makhana", "price": 120 },
          { "name": "Khesari Dal", "price": 65 },
          { "name": "Vaal", "price": 55 },
          { "name": "Gahat Dal", "price": 80 },
          { "name": "Urad Gota", "price": 70 },
          { "name": "Cholai", "price": 50 },
          { "name": "Masoor Dal Red", "price": 60 },
          { "name": "Urad Dal Black", "price": 75 },
          { "name": "Rongi", "price": 50 },
          { "name": "Chickpeas", "price": 90 },
          { "name": "Horse Gram Brown", "price": 65 },
          { "name": "Whole Brown Lentils", "price": 70 },
          { "name": "Whole Red Lentils", "price": 65 },
          { "name": "Lentils Split", "price": 75 },
          { "name": "Split Beans", "price": 55 },
          { "name": "Whole Beans", "price": 80 },
          { "name": "Fava Beans Split", "price": 100 },
          { "name": "Bengal Gram", "price": 90 },
          { "name": "Chickpeas Black", "price": 55 },
          { "name": "Red Beans", "price": 85 },
          { "name": "Soy Beans Black", "price": 90 },
          { "name": "Navy Beans White", "price": 105 },
          { "name": "Cannellini Beans White", "price": 110 },
          { "name": "Red Kidney Beans", "price": 95 },
          { "name": "Black Eyed Beans", "price": 70 },
          { "name": "Green Moong Beans", "price": 65 },
          { "name": "Brown Chickpeas", "price": 55 },
          { "name": "Chana Dal Yellow", "price": 50 },
          { "name": "Whole Red Beans", "price": 85 },
          { "name": "Whole Yellow Peas", "price": 55 },
          { "name": "Whole Green Peas", "price": 50 },
          { "name": "Dried Peas", "price": 60 },
          { "name": "Chickpeas White", "price": 90 },
          { "name": "White Chickpeas", "price": 85 },
          { "name": "Black Chickpeas", "price": 55 },
          { "name": "Split Peas", "price": 60 },
          { "name": "Dry Peas", "price": 70 },
          { "name": "Whole Yellow Beans", "price": 80 },
          { "name": "Red Lentils Split", "price": 65 },
          { "name": "Green Lentils Split", "price": 70 }
        ],
      
        
          "Spices": [
            { "name": "Turmeric Powder", "price": 30 },
            { "name": "Chili Powder", "price": 40 },
            { "name": "Cumin Seeds", "price": 50 },
            { "name": "Coriander Powder", "price": 35 },
            { "name": "Garam Masala", "price": 60 },
            { "name": "Black Pepper", "price": 80 },
            { "name": "Fenugreek Seeds", "price": 40 },
            { "name": "Mustard Seeds", "price": 20 },
            { "name": "Fennel Seeds", "price": 30 },
            { "name": "Cloves", "price": 100 },
            { "name": "Cinnamon", "price": 90 },
            { "name": "Cardamom", "price": 150 },
            { "name": "Bay Leaves", "price": 25 },
            { "name": "Star Anise", "price": 120 },
            { "name": "Nutmeg", "price": 70 },
            { "name": "Mace", "price": 80 },
            { "name": "Asafoetida", "price": 35 },
            { "name": "Carom Seeds", "price": 45 },
            { "name": "Poppy Seeds", "price": 60 },
            { "name": "Nigella Seeds", "price": 55 },
            { "name": "Saffron", "price": 300 },
            { "name": "Kasuri Methi", "price": 50 },
            { "name": "Dry Ginger", "price": 40 },
            { "name": "White Pepper", "price": 100 },
            { "name": "Green Cardamom", "price": 150 },
            { "name": "Black Cardamom", "price": 80 },
            { "name": "Fennel Powder", "price": 35 },
            { "name": "Coriander Seeds", "price": 45 },
            { "name": "Cumin Powder", "price": 55 },
            { "name": "Dry Mango Powder", "price": 50 },
            { "name": "Anardana", "price": 45 },
            { "name": "Sumac", "price": 70 },
            { "name": "Allspice", "price": 75 },
            { "name": "Galangal", "price": 60 },
            { "name": "Lemongrass", "price": 40 },
            { "name": "Turmeric Root", "price": 30 },
            { "name": "Smoked Paprika", "price": 80 },
            { "name": "Cayenne Pepper", "price": 50 },
            { "name": "Paprika", "price": 60 },
            { "name": "Curry Leaves", "price": 20 },
            { "name": "Curry Powder", "price": 55 },
            { "name": "Ginger Powder", "price": 40 },
            { "name": "Garlic Powder", "price": 45 },
            { "name": "Onion Powder", "price": 35 },
            { "name": "Red Chili Flakes", "price": 50 },
            { "name": "Sesame Seeds", "price": 30 },
            { "name": "Basil", "price": 25 },
            { "name": "Oregano", "price": 30 },
            { "name": "Thyme", "price": 35 },
            { "name": "Rosemary", "price": 40 },
            { "name": "Parsley", "price": 20 },
            { "name": "Tarragon", "price": 45 },
            { "name": "Chervil", "price": 50 },
            { "name": "Dill", "price": 25 },
            { "name": "Mint", "price": 30 },
            { "name": "Sage", "price": 35 },
            { "name": "Bay Leaf Powder", "price": 30 },
            { "name": "Fenugreek Powder", "price": 35 },
            { "name": "Caraway Seeds", "price": 50 },
            { "name": "Celery Seeds", "price": 40 },
            { "name": "Ajwain Powder", "price": 45 },
            { "name": "Curry Leaf Powder", "price": 35 },
            { "name": "Dried Fenugreek Leaves", "price": 50 },
            { "name": "Dried Mint Leaves", "price": 25 },
            { "name": "Dried Coriander Leaves", "price": 30 },
            { "name": "Dried Parsley", "price": 20 },
            { "name": "Chia Seeds", "price": 60 },
            { "name": "Sunflower Seeds", "price": 55 },
            { "name": "Pumpkin Seeds", "price": 50 },
            { "name": "Flax Seeds", "price": 45 },
            { "name": "Basil Seeds", "price": 35 },
            { "name": "Chili Powder Kashmiri", "price": 50 },
            { "name": "Black Salt", "price": 20 },
            { "name": "Rock Salt", "price": 25 },
            { "name": "Pink Salt", "price": 30 },
            { "name": "White Pepper Powder", "price": 90 },
            { "name": "Black Pepper Powder", "price": 85 },
            { "name": "Chaat Masala", "price": 40 },
            { "name": "Tandoori Masala", "price": 60 },
            { "name": "Panch Phoron", "price": 50 },
            { "name": "Chili Flakes", "price": 45 },
            { "name": "Cinnamon Powder", "price": 35 },
            { "name": "Cardamom Powder", "price": 70 },
            { "name": "Clove Powder", "price": 65 },
            { "name": "Nutmeg Powder", "price": 55 },
            { "name": "Mustard Powder", "price": 20 },
            { "name": "Saffron Threads", "price": 300 },
            { "name": "Ginger Garlic Paste", "price": 50 },

            
  { "name": "Everest Shahi Biryani Masala", "price": 83 },
  { "name": "Aachi Biryani Masala", "price": 36 },
  { "name": "Catch Biryani Masala", "price": 63 },
  { "name": "Shan Bombay Biryani Masala", "price": 98 },
  { "name": "Suhana Chicken Biryani Masala", "price": 33 },
  { "name": "Nawab's Secret Hyderabadi Biryani Masala", "price": 89 },
  { "name": "Cookme Handi Biryani Masala", "price": 90 },
  { "name": "Organic Tattva Biryani Masala", "price": 150 },
  { "name": "India Gate Hyderabadi Biryani Masala", "price": 49 },
  { "name": "Badshah Biryani Masala", "price": 66 },
  { "name": "Mother's Recipe Chicken Biryani Mix", "price": 49 },
  { "name": "Kalprishi Spicy Biryani Masala", "price": 94 },


  { "name": "Jathipatri (Mace)", "price": 110 },
  { "name": "Kalpasi (Black Stone Flower)", "price": 65 },
  { "name": "Star Anise", "price": 70 },
  { "name": "Jathikai (Nutmeg)", "price": 100 },
  { "name": "Marathi Moggu (Kapok Buds)", "price": 60 },
  { "name": "jagikayi", "price": 100 },
  { "name": "Kasthuri pasupu", "price": 260 },


  
  { "name": "Maida (Refined Flour)", "price": 45 },
  { "name": "Besan (Gram Flour)", "price": 60 },
  { "name": "Rice Flour", "price": 50 },
  { "name": "Wheat Flour (Atta)", "price": 55 },
  { "name": "Corn Flour", "price": 40 },
  { "name": "Ragi Flour (Finger Millet)", "price": 65 },
  { "name": "Jowar Flour (Sorghum)", "price": 60 },
  { "name": "Bajra Flour (Pearl Millet)", "price": 58 },
  { "name": "Sattu (Roasted Gram Flour)", "price": 70 },
  { "name": "Soybean Flour", "price": 62 },
  { "name": "Oats Powder", "price": 75 },
  { "name": "Almond Powder", "price": 320 },
  { "name": "Coconut Powder", "price": 90 },
  { "name": "Milk Powder", "price": 120 },
  { "name": "Coffee Powder", "price": 150 },
  { "name": "Cocoa Powder", "price": 140 },
  

          ],
           "Others":[
            { "name": "Other Items", "price": 120 },
              { "name": "Loose Items", "price": 100 },
              { "name": "Piece Rates", "price": 50 },
              { "name": "Extra Item", "price": 20 },
              { "name": "Others", "price": 80 },
              { "name": "Miscelleneous Items", "price": 25 },

{ "name": "Night Pants", "price": 799 },
{ "name": "Inner wear", "price": 299 },
              
  { "name": "Chudidhar Set", "price": 799 },
  { "name": "Kurti with Leggings", "price": 699 },
  { "name": "Saree Blouse", "price": 399 },
  { "name": "Salwar Kameez", "price": 850 },
  { "name": "Nighty", "price": 550 },
  { "name": "Bra (Jockey)", "price": 575 },
  { "name": "Panty (Rupa)", "price": 285 },
  { "name": "Camisole", "price": 199 },
  { "name": "Maternity Wear", "price": 899 },
  { "name": "Infant Onesie", "price": 299 },
  { "name": "Infant Frock", "price": 350 },
  { "name": "Infant Pajama Set", "price": 399 },
  { "name": "Infant Mittens", "price": 144 },
  { "name": "Infant Cap", "price": 120 },
  { "name": "Infant Socks", "price": 99 },
  { "name": "Jockey Banian (Vest)", "price": 319 },
  { "name": "Lux Cozi Vest", "price": 299 },
  { "name": "Dixcy Scott Trunk", "price": 355 },
  { "name": "Lungi (Cotton)", "price": 250 },
  { "name": "Dhoti (Silk Blend)", "price": 499 },
  { "name": "Petticoat", "price": 249 },
  { "name": "Saree Shapewear", "price": 298 },
  { "name": "Leggings", "price": 299 },
  { "name": "Palazzo Pants", "price": 399 },
  { "name": "Dupatta", "price": 199 },
  { "name": "Anarkali Suit", "price": 780 },
  { "name": "Lehenga Choli", "price": 1200 },
  { "name": "Sports Bra", "price": 360 },
  { "name": "Period Panty", "price": 458 },
  { "name": "Cotton Shorts", "price": 275 },


           ],
          
            "Oils": [
              { "name": "Sunflower Oil", "price": 120 },
              { "name": "Mustard Oil", "price": 100 },
              { "name": "Olive Oil", "price": 250 },
              { "name": "Coconut Oil", "price": 200 },
              { "name": "Sesame Oil", "price": 150 },
              { "name": "Groundnut Oil", "price": 140 },
              { "name": "Safflower Oil", "price": 130 },
              { "name": "Soybean Oil", "price": 110 },
              { "name": "Rice Bran Oil", "price": 160 },
              { "name": "Palm Oil", "price": 90 },
              { "name": "Corn Oil", "price": 100 },
              { "name": "Canola Oil", "price": 180 },
              { "name": "Avocado Oil", "price": 300 },
              { "name": "Almond Oil", "price": 350 },
              { "name": "Walnut Oil", "price": 400 },
              { "name": "Grape Seed Oil", "price": 220 },
              { "name": "Flaxseed Oil", "price": 270 },
              { "name": "Hemp Oil", "price": 320 },
              { "name": "Peanut Oil", "price": 140 },
              { "name": "Macadamia Oil", "price": 450 },
              { "name": "Hazelnut Oil", "price": 380 },
              { "name": "Pumpkin Seed Oil", "price": 240 },
              { "name": "Sesame Oil (Toasted)", "price": 160 },
              { "name": "Tea Seed Oil", "price": 330 },
              { "name": "Argan Oil", "price": 500 },
              { "name": "Castor Oil", "price": 120 },
              { "name": "Neem Oil", "price": 110 },
              { "name": "Karanja Oil", "price": 100 },
              { "name": "Pongamia Oil", "price": 90 },
              { "name": "Baobab Oil", "price": 350 },
              { "name": "Moringa Oil", "price": 400 },
              { "name": "Jojoba Oil", "price": 450 },
              { "name": "Rosehip Oil", "price": 500 },
              { "name": "Tamanu Oil", "price": 380 },
              { "name": "Camellia Oil", "price": 320 },
              { "name": "Borage Oil", "price": 340 },
              { "name": "Black Seed Oil", "price": 290 },
              { "name": "Evening Primrose Oil", "price": 360 },
              { "name": "Apricot Kernel Oil", "price": 250 },
              { "name": "Kukui Nut Oil", "price": 330 },
              { "name": "Marula Oil", "price": 480 },
              { "name": "Pomegranate Seed Oil", "price": 420 },
              { "name": "Sea Buckthorn Oil", "price": 410 },
              { "name": "Squalane Oil", "price": 470 },
              { "name": "Cranberry Seed Oil", "price": 430 },
              { "name": "Raspberry Seed Oil", "price": 400 },
              { "name": "Blueberry Seed Oil", "price": 380 },
              { "name": "Broccoli Seed Oil", "price": 360 },
              { "name": "Watermelon Seed Oil", "price": 350 },
              { "name": "Cucumber Seed Oil", "price": 340 },
              { "name": "Tomato Seed Oil", "price": 320 },
              { "name": "Strawberry Seed Oil", "price": 330 },
              { "name": "Kiwi Seed Oil", "price": 370 },
              { "name": "Passion Fruit Seed Oil", "price": 420 },
              { "name": "Papaya Seed Oil", "price": 380 },
              { "name": "Guava Seed Oil", "price": 360 },
              { "name": "Blackberry Seed Oil", "price": 400 },
              { "name": "Cherry Seed Oil", "price": 380 },
              { "name": "Grapefruit Seed Oil", "price": 360 },
              { "name": "Lemon Seed Oil", "price": 340 },
              { "name": "Lime Seed Oil", "price": 320 },
              { "name": "Orange Seed Oil", "price": 300 },
              { "name": "Tangerine Seed Oil", "price": 280 },
              { "name": "Mandarin Seed Oil", "price": 260 },
              { "name": "Bitter Orange Seed Oil", "price": 240 },
              { "name": "Sweet Orange Seed Oil", "price": 220 },
              { "name": "Bergamot Seed Oil", "price": 200 },
              { "name": "Yuzu Seed Oil", "price": 180 },
              { "name": "Safflower Oil (High Oleic)", "price": 160 },
              { "name": "Safflower Oil (High Linoleic)", "price": 140 },
              { "name": "Corn Oil (Refined)", "price": 120 },
              { "name": "Corn Oil (Unrefined)", "price": 100 },
              { "name": "Canola Oil (Refined)", "price": 150 },
              { "name": "Canola Oil (Unrefined)", "price": 130 },
              { "name": "Sunflower Oil (Refined)", "price": 140 },
              { "name": "Sunflower Oil (Unrefined)", "price": 120 },
              { "name": "Olive Oil (Refined)", "price": 270 },
              { "name": "Olive Oil (Unrefined)", "price": 250 },
              { "name": "Coconut Oil (Refined)", "price": 220 },
              { "name": "Coconut Oil (Unrefined)", "price": 200 },
              { "name": "Soybean Oil (Refined)", "price": 130 },
              { "name": "Soybean Oil (Unrefined)", "price": 110 },



  { "name": "Parachute Coconut Oil", "price": 120 },
  { "name": "Saffola Gold (Rice Bran & Corn)", "price": 160 },
  { "name": "Fortune Sunlite Sunflower Oil", "price": 150 },
  { "name": "Figaro Olive Oil", "price": 220 },
  { "name": "Dhara Mustard Oil", "price": 130 },
  { "name": "Patanjali Mustard Oil", "price": 125 },
  { "name": "Emami Healthy & Tasty Soybean Oil", "price": 145 },
  { "name": "Sundrop Superlite Sunflower Oil", "price": 155 },
  { "name": "Gold Winner Refined Sunflower Oil", "price": 165 },
  { "name": "IDHAYAM Sesame Oil", "price": 170 },
  { "name": "Freedom Groundnut Oil", "price": 175 },
  { "name": "Anveshan Wood Pressed Coconut Oil", "price": 190 },
  { "name": "JIVO Extra Virgin Olive Oil", "price": 210 },
  { "name": "Kapiva Virgin Coconut Oil", "price": 180 },
  { "name": "Kalash Mustard Oil", "price": 135 },
  { "name": "Double Sher Mustard Oil", "price": 140 },
  { "name": "KS Gold Mustard Oil", "price": 145 },
  { "name": "Pansari Kacchi Ghani Mustard Oil", "price": 135 },
  { "name": "JIVO Rice Bran Oil", "price": 160 },
  { "name": "Laxmi Organic Extra Virgin Olive Oil", "price": 200 },
  { "name": "Pure & Sure Groundnut Oil", "price": 170 },
  { "name": "Organic Tattva Coconut Oil", "price": 185 },
  { "name": "24 Mantra Organic Mustard Oil", "price": 150 },
  { "name": "Natureland Organic Sesame Oil", "price": 165 },
  { "name": "Figaro Pure Olive Oil", "price": 210 },



            ],
          
        
              "Snacks": [
                { "name": "Potato Chips", "price": 20 },
                { "name": "Biscuits", "price": 30 },
                { "name": "Nachos", "price": 50 },
                { "name": "Pretzels", "price": 40 },
                { "name": "Popcorn", "price": 30 },
                { "name": "Peanuts", "price": 25 },
                { "name": "Almonds", "price": 150 },
                { "name": "Cashews", "price": 200 },
                { "name": "Trail Mix", "price": 100 },
                { "name": "Granola Bars", "price": 120 },
                { "name": "Energy Bars", "price": 140 },
                { "name": "Protein Bars", "price": 160 },
                { "name": "Fruit Snacks", "price": 40 },
                { "name": "Dry Fruits", "price": 180 },
                { "name": "Chocolate Bars", "price": 50 },
                { "name": "Candy", "price": 20 },
                { "name": "Gummies", "price": 25 },
                { "name": "Lollipops", "price": 15 },
                { "name": "Cookies", "price": 35 },
                { "name": "Wafers", "price": 20 },
                { "name": "Crackers", "price": 45 },
                { "name": "Breadsticks", "price": 30 },
                { "name": "Cheese Balls", "price": 50 },
                { "name": "Mini Pretzels", "price": 25 },
                { "name": "Rice Cakes", "price": 40 },
                { "name": "Corn Chips", "price": 30 },
                { "name": "Pita Chips", "price": 35 },
                { "name": "Veggie Chips", "price": 60 },
                { "name": "Kale Chips", "price": 70 },
                { "name": "Banana Chips", "price": 50 },
                { "name": "Plantain Chips", "price": 45 },
                { "name": "Sweet Potato Chips", "price": 55 },
                { "name": "Multigrain Chips", "price": 65 },
                { "name": "Nuts Mix", "price": 130 },
                { "name": "Seed Mix", "price": 90 },
                { "name": "Roasted Chickpeas", "price": 80 },
                { "name": "Corn Nuts", "price": 35 },
                { "name": "Rice Crackers", "price": 25 },
                { "name": "Mochi", "price": 75 },
                { "name": "Samosa", "price": 30 },
                { "name": "Kachori", "price": 20 },
                { "name": "Dhokla", "price": 50 },
                { "name": "Handvo", "price": 60 },
                { "name": "Thepla", "price": 40 },
                { "name": "Khakhra", "price": 30 },
                { "name": "Farsan", "price": 25 },
                { "name": "Chevdo", "price": 35 },
                { "name": "Chakri", "price": 30 },
                { "name": "Sev", "price": 20 },
                { "name": "Murukku", "price": 25 },
                { "name": "Pakora", "price": 40 },
                { "name": "Bhajiya", "price": 35 },
                { "name": "Vada", "price": 50 },
                { "name": "Samosa Puffs", "price": 60 },
                { "name": "Mini Pizzas", "price": 70 },
                { "name": "Spring Rolls", "price": 80 },
                { "name": "Cheese Sticks", "price": 50 },
                { "name": "Fish Fingers", "price": 90 },
                { "name": "Chicken Nuggets", "price": 100 },
                { "name": "Mini Burgers", "price": 120 },
                { "name": "Hot Dogs", "price": 130 },
                { "name": "Mini Sandwiches", "price": 140 },
                { "name": "Tacos", "price": 150 },
                { "name": "Quesadillas", "price": 160 },
                { "name": "Taquitos", "price": 170 },
                { "name": "Empanadas", "price": 180 },
                { "name": "Puffs", "price": 50 },
                { "name": "Egg Rolls", "price": 60 },
                { "name": "Paneer Tikka", "price": 70 },
                { "name": "Chicken Tikka", "price": 80 },
                { "name": "Fish Tikka", "price": 90 },
                { "name": "Mutton Kebab", "price": 100 },
                { "name": "Paneer Kebab", "price": 110 },
                { "name": "Vegetable Kebab", "price": 120 },
                { "name": "Veg Cutlets", "price": 50 },
                { "name": "Veg Patties", "price": 60 },
                { "name": "Paneer Patties", "price": 70 },
                { "name": "Chicken Patties", "price": 80 },
                { "name": "Fish Patties", "price": 90 },
                { "name": "Mini Samosas", "price": 30 },
                { "name": "Mini Kachoris", "price": 20 },
                { "name": "Cheese Crackers", "price": 40 },
                { "name": "Salted Biscuits", "price": 30 },
                { "name": "Cream Biscuits", "price": 50 },
                { "name": "Digestive Biscuits", "price": 40 },


                
  { "name": "Cadbury Dairy Milk", "price": 90 },
  { "name": "Cadbury 5 Star", "price": 85 },
  { "name": "Cadbury Perk", "price": 40 },
  { "name": "Cadbury Gems", "price": 35 },
  { "name": "Cadbury Bournville", "price": 110 },
  { "name": "Cadbury Silk", "price": 120 },
  { "name": "Nestlé KitKat", "price": 45 },
  { "name": "Nestlé Munch", "price": 30 },
  { "name": "Nestlé Milkybar", "price": 35 },
  { "name": "Amul Dark Chocolate", "price": 70 },
  { "name": "Amul Fruit 'n' Nut", "price": 75 },
  { "name": "Parle Melody", "price": 10 },
  { "name": "Parle Kismi", "price": 10 },
  { "name": "Mars Bar", "price": 95 },
  { "name": "Snickers", "price": 85 },
  { "name": "Ferrero Rocher", "price": 150 },
  { "name": "Toblerone", "price": 130 },
  { "name": "Lotte Choco Pie", "price": 60 },
  { "name": "Hershey's Kisses", "price": 140 },
  { "name": "Fabelle Exquisite Chocolates", "price": 160 },

  
  { "name": "Britannia Good Day", "price": 30 },
  { "name": "Britannia Bourbon", "price": 35 },
  { "name": "Britannia Marie Gold", "price": 25 },
  { "name": "Britannia Little Hearts", "price": 20 },
  { "name": "Parle-G", "price": 10 },
  { "name": "Parle Krackjack", "price": 15 },
  { "name": "Parle Hide & Seek", "price": 25 },
  { "name": "Parle Monaco", "price": 15 },
  { "name": "Sunfeast Mom's Magic", "price": 40 },
  { "name": "Sunfeast Dark Fantasy Choco Fills", "price": 60 },
  { "name": "Sunfeast Marie Light", "price": 20 },
  { "name": "Priya Gold Butter Bite", "price": 30 },
  { "name": "Priya Gold CNC", "price": 25 },
  { "name": "Unibic Choco Chip Cookies", "price": 50 },
  { "name": "Oreo", "price": 35 },
  { "name": "Anmol Dream Lite", "price": 20 },
  { "name": "Dukes Bourbon", "price": 30 },
  { "name": "Cremica Digestive", "price": 40 },
  { "name": "McVitie's Digestive", "price": 45 },
  { "name": "Patanjali Marie Biscuits", "price": 20 },


  { "name": "Knorr Tomato Soup", "price": 10 },
  { "name": "Ching's Manchow Soup", "price": 15 },
  { "name": "Maggi Hot & Sour Soup", "price": 12 },
  { "name": "Keya Creamy Mushroom Soup", "price": 13 },
  { "name": "Kellogg's Chocos", "price": 120 },
  { "name": "Patanjali Choco Flakes", "price": 95 },
  { "name": "Nestlé Koko Krunch", "price": 135 },
  { "name": "Saffola Oats with Fruits & Nuts", "price": 160 },
  { "name": "Quaker Oats Fruit & Nut", "price": 150 },
  { "name": "True Elements Fruit & Nut Oats", "price": 175 },


  
  { "name": "Maggi Noodles", "price": 14 },
  { "name": "Yippee Noodles", "price": 15 },
  { "name": "Top Ramen", "price": 12 },
  { "name": "Knorr Soupy Noodles", "price": 18 },
  { "name": "Ching's Secret Schezwan Noodles", "price": 20 },
  { "name": "Lays Magic Masala", "price": 20 },
  { "name": "Kurkure Masala Munch", "price": 10 },
  { "name": "Bingo Mad Angles", "price": 20 },
  { "name": "Too Yumm! Veggie Stix", "price": 25 },
  { "name": "Balaji Wafers", "price": 15 },
  { "name": "Yellow Diamond Rings", "price": 10 },
  { "name": "Haldiram's Bhujia", "price": 35 },
  { "name": "Bikano Aloo Bhujia", "price": 30 },
  { "name": "Pringles Original", "price": 99 },
  { "name": "Uncle Chipps", "price": 20 },
  { "name": "Act II Popcorn", "price": 30 },
  { "name": "Paper Boat Chikki", "price": 25 },
  { "name": "Sunfeast Yippee Pasta", "price": 25 },
  { "name": "Nestlé Everyday Poha", "price": 30 },
  { "name": "MTR Ready-to-Eat Upma", "price": 45 },
  { "name": "ITC Kitchens Biryani Mix", "price": 60 },
  { "name": "Haldiram's Ready Meals", "price": 80 },
  { "name": "Bikaji Namkeen Mix", "price": 35 },
  { "name": "Kissan Fruit Roll", "price": 20 },
  { "name": "Snac Tac Nachos", "price": 40 },



  { "name": "Tiktoc ", "price": 5 },
  { "name": "Boomer Bubble Gum", "price": 5 },
  { "name": "Center Fresh", "price": 5 },
  { "name": "Big Babool", "price": 5 },
  { "name": "Mentos", "price": 10 },
  { "name": "Pulse Candy", "price": 5 },
  { "name": "Eclairs", "price": 2 },
  { "name": "Kismi Toffee", "price": 2 },
  { "name": "Perk", "price": 10 },
  { "name": "KitKat", "price": 20 },
  { "name": "Red Bull", "price": 130 },
  { "name": "Paper Boat Aam Panna", "price": 30 },
  { "name": "Appy Fizz", "price": 45 },
  { "name": "Frooti", "price": 20 },
  { "name": "Bournvita Biscuits", "price": 25 },
  { "name": "Monster drink", "price": 105 },




              ],
            
            
    
              
                "Beverages": [
                  { "name": "Tea", "price": 150 },
                  { "name": "Coffee", "price": 200 },
                  { "name": "Green Tea", "price": 180 },
                  { "name": "Black Tea", "price": 170 },
                  { "name": "Herbal Tea", "price": 190 },
                  { "name": "Oolong Tea", "price": 220 },
                  { "name": "Chamomile Tea", "price": 210 },
                  { "name": "Peppermint Tea", "price": 200 },
                  { "name": "Jasmine Tea", "price": 230 },
                  { "name": "Lemon Tea", "price": 160 },
                  { "name": "Iced Tea", "price": 180 },
                  { "name": "Lemonade", "price": 120 },
                  { "name": "Orange Juice", "price": 150 },
                  { "name": "Apple Juice", "price": 140 },
                  { "name": "Grape Juice", "price": 160 },
                  { "name": "Cranberry Juice", "price": 170 },
                  { "name": "Pineapple Juice", "price": 180 },
                  { "name": "Mango Juice", "price": 150 },
                  { "name": "Tomato Juice", "price": 130 },
                  { "name": "Carrot Juice", "price": 140 },
                  { "name": "Beetroot Juice", "price": 150 },
                  { "name": "Mixed Fruit Juice", "price": 160 },
                  { "name": "Coconut Water", "price": 90 },
                  { "name": "Almond Milk", "price": 200 },
                  { "name": "Soy Milk", "price": 180 },
                  { "name": "Oat Milk", "price": 190 },
                  { "name": "Cashew Milk", "price": 210 },
                  { "name": "Rice Milk", "price": 170 },
                  { "name": "Hemp Milk", "price": 220 },
                  { "name": "Matcha Latte", "price": 250 },
                  { "name": "Turmeric Latte", "price": 240 },
                  { "name": "Hot Chocolate", "price": 180 },
                  { "name": "Milkshake", "price": 150 },
                  { "name": "Smoothie", "price": 200 },
                  { "name": "Protein Shake", "price": 220 },
                  { "name": "Whey Protein Shake", "price": 230 },
                  { "name": "Casein Protein Shake", "price": 240 },
                  { "name": "Soy Protein Shake", "price": 210 },
                  { "name": "Pea Protein Shake", "price": 220 },
                  { "name": "Rice Protein Shake", "price": 230 },
                  { "name": "Egg White Protein Shake", "price": 250 },
                  { "name": "Beef Protein Shake", "price": 270 },
                  { "name": "Collagen Protein Shake", "price": 260 },
                  { "name": "Almond Protein Shake", "price": 280 },
                  { "name": "Coconut Milkshake", "price": 190 },
                  { "name": "Avocado Smoothie", "price": 210 },
                  { "name": "Berry Smoothie", "price": 220 },
                  { "name": "Banana Smoothie", "price": 200 },
                  { "name": "Strawberry Smoothie", "price": 210 },
                  { "name": "Mango Smoothie", "price": 220 },
                  { "name": "Papaya Smoothie", "price": 190 },
                  { "name": "Watermelon Smoothie", "price": 180 },
                  { "name": "Pineapple Smoothie", "price": 200 },
                  { "name": "Kombucha", "price": 250 },
                  { "name": "Herbal Infusion", "price": 230 },
                  { "name": "Fruit Infusion", "price": 240 },
                  { "name": "Vegetable Juice", "price": 150 },
                  { "name": "Detox Water", "price": 100 },
                  { "name": "Sports Drink", "price": 120 },
                  { "name": "Energy Drink", "price": 140 },
                  { "name": "Electrolyte Drink", "price": 130 },
                  { "name": "Protein Drink", "price": 150 },
                  { "name": "Meal Replacement Shake", "price": 250 },
                  { "name": "Flavored Water", "price": 90 },
                  { "name": "Sparkling Water", "price": 80 },
                  { "name": "Tonic Water", "price": 100 },
                  { "name": "Club Soda", "price": 90 },
                  { "name": "Ginger Ale", "price": 110 },
                  { "name": "Root Beer", "price": 120 },
                  { "name": "Cola", "price": 130 },
                  { "name": "Diet Cola", "price": 140 },
                  { "name": "Lime Soda", "price": 150 },
                  { "name": "Lemon Soda", "price": 140 },
                  { "name": "Orange Soda", "price": 130 },
                  { "name": "Berry Soda", "price": 150 },
                  { "name": "Grape Soda", "price": 160 },
                  { "name": "Apple Cider", "price": 180 },
                  { "name": "Pear Cider", "price": 190 },
                  { "name": "Plum Cider", "price": 200 },
                  { "name": "Mulled Wine", "price": 300 },
                  { "name": "Sangria", "price": 250 },
                  { "name": "Mocktail", "price": 180 },
                  { "name": "Virgin Mojito", "price": 160 },
                  { "name": "Virgin Pina Colada", "price": 170 },
                  { "name": "Virgin Margarita", "price": 190 },
                  { "name": "Virgin Daiquiri", "price": 200 },
                  { "name": "Virgin Martini", "price": 210 },
                  { "name": "Virgin Bloody Mary", "price": 220 },

                  
  { "name": "Thums Up", "price": 35 },
  { "name": "Maaza", "price": 45 },
  { "name": "Coca-Cola", "price": 40 },
  { "name": "Pepsi", "price": 40 },
  { "name": "Sprite", "price": 36 },
  { "name": "Fanta", "price": 31 },
  { "name": "Limca", "price": 40 },
  { "name": "7UP", "price": 37 },
  { "name": "Mountain Dew", "price": 40 },
  { "name": "Mirinda", "price": 35 },
  { "name": "Appy Fizz", "price": 45 },
  { "name": "Slice", "price": 42 },
  { "name": "Paper Boat Aamras", "price": 30 },
  { "name": "Bovonto", "price": 25 },
  { "name": "Sting", "price": 25 },
  { "name": "Bisleri Limonata", "price": 28 },
  { "name": "Campa Cola", "price": 30 },
  { "name": "RC Cola", "price": 32 },
  { "name": "Xalta Cola", "price": 30 },
  { "name": "B-Fizz", "price": 35 },


                ],
              
                
                  "Vegetables": [
                    { "name": "Broccoli", "price": 60 },
                    { "name": "Carrot", "price": 40 },
                    { "name": "Cauliflower", "price": 50 },
                    { "name": "Potato", "price": 30 },
                    { "name": "Tomato", "price": 40 },
                    { "name": "Onion", "price": 30 },
                    { "name": "Garlic", "price": 20 },
                    { "name": "Ginger", "price": 40 },
                    { "name": "Spinach", "price": 30 },
                    { "name": "Lettuce", "price": 40 },
                    { "name": "Cabbage", "price": 30 },
                    { "name": "Beans", "price": 40 },
                    { "name": "Peas", "price": 30 },
                    { "name": "Corn", "price": 20 },
                    { "name": "Cucumber", "price": 20 },
                    { "name": "Capsicum", "price": 50 },
                    { "name": "Mushrooms", "price": 100 },
                    { "name": "Eggplant", "price": 30 },
                    { "name": "Zucchini", "price": 30 },
                    { "name": "Squash", "price": 40 },
                    { "name": "Pumpkin", "price": 50 },
                    { "name": "Okra", "price": 60 },
                    { "name": "Asparagus", "price": 120 },
                    { "name": "Artichoke", "price": 110 },
                    { "name": "Brussels Sprouts", "price": 90 },
                    { "name": "Bok Choy", "price": 70 },
                    { "name": "Swiss Chard", "price": 80 },
                    { "name": "Kale", "price": 100 },
                    { "name": "Turnip", "price": 30 },
                    { "name": "Radish", "price": 20 },
                    { "name": "Sweet Potato", "price": 40 },
                    { "name": "Bell Pepper", "price": 40 },
                    { "name": "Chili Pepper", "price": 30 },
                    { "name": "Beetroot", "price": 20 },
                    { "name": "Leek", "price": 50 },
                    { "name": "Celery", "price": 40 },
                    { "name": "Parsnip", "price": 60 },
                    { "name": "Fennel", "price": 70 },
                    { "name": "Green Beans", "price": 40 },
                    { "name": "Snow Peas", "price": 50 },
                    { "name": "Chayote", "price": 40 },
                    { "name": "Bitter Gourd", "price": 60 },
                    { "name": "Bottle Gourd", "price": 40 },
                    { "name": "Pointed Gourd", "price": 30 },
                    { "name": "Snake Gourd", "price": 50 },
                    { "name": "Ivy Gourd", "price": 30 },
                    { "name": "Drumstick", "price": 50 },
                    { "name": "Yam", "price": 40 },
                    { "name": "Taro Root", "price": 30 },
                    { "name": "Lotus Root", "price": 50 },
                    { "name": "Kohlrabi", "price": 40 },
                    { "name": "Radicchio", "price": 70 },
                    { "name": "Endive", "price": 60 },
                    { "name": "Mustard Greens", "price": 50 },
                    { "name": "Collard Greens", "price": 40 },
                    { "name": "Rapini", "price": 60 },
                    { "name": "Sorrel", "price": 50 },
                    { "name": "Dandelion Greens", "price": 40 },
                    { "name": "Broccoli Rabe", "price": 70 },
                    { "name": "Arugula", "price": 50 },
                    { "name": "Watercress", "price": 60 },
                    { "name": "Mizuna", "price": 40 },
                    { "name": "Chicory", "price": 50 },
                    { "name": "Beet Greens", "price": 40 },
                    { "name": "Kaleidoscope Carrots", "price": 60 },
                    { "name": "Rainbow Chard", "price": 70 },
                    { "name": "Purple Cauliflower", "price": 80 },
                    { "name": "Romanesco", "price": 90 },
                    { "name": "Yellow Squash", "price": 40 },
                    { "name": "Pattypan Squash", "price": 50 },
                    { "name": "Spaghetti Squash", "price": 60 },
                    { "name": "Delicata Squash", "price": 70 },
                    { "name": "Kabocha Squash", "price": 80 },
                    { "name": "Turban Squash", "price": 90 },
                    { "name": "Acorn Squash", "price": 40 },
                    { "name": "Butternut Squash", "price": 50 },
                    { "name": "Hubbard Squash", "price": 60 },
                    { "name": "Buttercup Squash", "price": 70 },
                    { "name": "Cushaw Squash", "price": 80 },
                    { "name": "Banana Squash", "price": 90 },
                    { "name": "Chard", "price": 40 },
                    { "name": "Savoy Cabbage", "price": 50 },
                    { "name": "Napa Cabbage", "price": 60 },
                    { "name": "Red Cabbage", "price": 70 },
                    { "name": "Green Cabbage", "price": 30 }
                  ],
                
                
                  "Fruits & Dry-Fruits": [
                    { "name": "Apple", "price": 150 },
                    { "name": "Banana", "price": 40 },
                    { "name": "Orange", "price": 60 },
                    { "name": "Grapes", "price": 80 },
                    { "name": "Mango", "price": 100 },
                    { "name": "Pineapple", "price": 80 },
                    { "name": "Papaya", "price": 50 },
                    { "name": "Watermelon", "price": 40 },
                    { "name": "Strawberry", "price": 120 },
                    { "name": "Blueberry", "price": 200 },
                    { "name": "Raspberry", "price": 250 },
                    { "name": "Blackberry", "price": 220 },
                    { "name": "Cherry", "price": 300 },
                    { "name": "Peach", "price": 100 },
                    { "name": "Plum", "price": 90 },
                    { "name": "Pear", "price": 60 },
                    { "name": "Kiwi", "price": 80 },
                    { "name": "Avocado", "price": 100 },
                    { "name": "Lychee", "price": 150 },
                    { "name": "Pomegranate", "price": 120 },
                    { "name": "Dragon Fruit", "price": 200 },
                    { "name": "Durian", "price": 250 },
                    { "name": "Jackfruit", "price": 100 },
                    { "name": "Tangerine", "price": 70 },
                    { "name": "Grapefruit", "price": 80 },
                    { "name": "Lime", "price": 30 },
                    { "name": "Lemon", "price": 40 },
                    { "name": "Cranberry", "price": 200 },
                    { "name": "Gooseberry", "price": 60 },
                    { "name": "Fig", "price": 100 },
                    { "name": "Date", "price": 150 },
                    { "name": "Raisin", "price": 120 },
                    { "name": "Apricot", "price": 80 },
                    { "name": "Nectarine", "price": 90 },
                    { "name": "Persimmon", "price": 110 },
                    { "name": "Guava", "price": 70 },
                    { "name": "Passion Fruit", "price": 130 },
                    { "name": "Custard Apple", "price": 80 },
                    { "name": "Mangosteen", "price": 250 },
                    { "name": "Starfruit", "price": 120 },
                    { "name": "Kumquat", "price": 60 },
                    { "name": "Quince", "price": 100 },
                    { "name": "Loquat", "price": 70 },
                    { "name": "Longan", "price": 90 },
                    { "name": "Sapodilla", "price": 50 },
                    { "name": "Rambutan", "price": 150 },
                    { "name": "Pomelo", "price": 120 },
                    { "name": "Soursop", "price": 180 },
                    { "name": "Pluot", "price": 110 },
                    { "name": "Jujube", "price": 90 },
                    { "name": "Cherimoya", "price": 200 },
                    { "name": "Mulberry", "price": 100 },
                    { "name": "Amla", "price": 60 },
                    { "name": "Bilberry", "price": 140 },
                    { "name": "Currant", "price": 120 },
                    { "name": "Barberry", "price": 130 },
                    { "name": "Elderberry", "price": 150 },
                    { "name": "Boysenberry", "price": 170 },
                    { "name": "Cloudberry", "price": 180 },
                    { "name": "Huckleberry", "price": 160 },
                    { "name": "Salak", "price": 190 },
                    { "name": "Prickly Pear", "price": 150 },
                    { "name": "Cactus Pear", "price": 160 },
                    { "name": "Tamarind", "price": 70 },
                    { "name": "Ackee", "price": 180 },
                    { "name": "Breadfruit", "price": 90 },
                    { "name": "Olives", "price": 80 },
                    { "name": "Artichoke", "price": 110 },
                    { "name": "Asparagus", "price": 120 },
                    { "name": "Brussels Sprouts", "price": 90 },
                    { "name": "Okra", "price": 60 },
                    { "name": "Bok Choy", "price": 70 },
                    { "name": "Swiss Chard", "price": 80 },
                    { "name": "Kale", "price": 100 },
                    { "name": "Turnip", "price": 30 },
                    { "name": "Radish", "price": 20 },
                    { "name": "Sweet Potato", "price": 40 },
                    { "name": "Zucchini", "price": 30 },
                    { "name": "Pumpkin", "price": 50 },
                    { "name": "Squash", "price": 60 },
                    { "name": "Eggplant", "price": 30 },
                    { "name": "Bell Pepper", "price": 40 },
                    { "name": "Chili Pepper", "price": 30 },
                    { "name": "Beetroot", "price": 20 },
                    { "name": "Radicchio", "price": 70 },

                    
  { "name": "Almonds (Badam)", "price": 320 },
  { "name": "Cashews (Kaju)", "price": 350 },
  { "name": "Walnuts (Akhrot)", "price": 400 },
  { "name": "Raisins (Kishmish)", "price": 250 },
  { "name": "Figs (Anjeer)", "price": 385 },
  { "name": "Dates (Khajoor)", "price": 270 },
  { "name": "Apricots (Khubani)", "price": 256 },
  { "name": "Prunes (Aloo Bukhara)", "price": 295 },
  { "name": "Pistachios (Pista)", "price": 310 },
  { "name": "Cranberries", "price": 229 },
  { "name": "Blueberries", "price": 298 },
  { "name": "Fox Nuts (Makhana)", "price": 180 },
  { "name": "Hazelnuts", "price": 330 },
  { "name": "Brazil Nuts", "price": 420 },
  { "name": "Chironji (Charoli)", "price": 260 },
  { "name": "Goji Berries", "price": 315 },
  { "name": "Sunflower Seeds", "price": 150 },
  { "name": "Pumpkin Seeds", "price": 160 },
  { "name": "Chia Seeds", "price": 140 },
  { "name": "Flax Seeds", "price": 130 },
  { "name": "Dry Coconut Slices", "price": 190 },
  { "name": "Dry Kiwi", "price": 240 },
  { "name": "Dry Pineapple", "price": 250 },
  { "name": "Dry Mango Slices", "price": 260 },
  { "name": "Dry Papaya Cubes", "price": 210 },



                  ],
                
                "Stationary": [
  { "name": "Markers", "price": 120 },
  { "name": "Glitters", "price": 100 },
  { "name": "High lighter", "price": 50 },
  { "name": "Pads", "price": 20 },
  { "name": "Other stationary", "price": 80 },
  { "name": "Miscelleneous Items", "price": 25 },
  { "name": "White Notebook", "price": 45 },
  { "name": "Lined Notebook", "price": 50 },
  { "name": "Drawing Book", "price": 60 },
  { "name": "Graph Book", "price": 55 },
  { "name": "Ball Pen (Blue)", "price": 10 },
  { "name": "Ball Pen (Black)", "price": 10 },
  { "name": "Gel Pen", "price": 15 },
  { "name": "Fountain Pen", "price": 40 },
  { "name": "Pencil (HB)", "price": 5 },
  { "name": "Pencil (2B)", "price": 6 },
  { "name": "Mechanical Pencil", "price": 25 },
  { "name": "Sharpener", "price": 8 },
  { "name": "Eraser", "price": 5 },
  { "name": "Scale (15 cm)", "price": 10 },
  { "name": "Scale (30 cm)", "price": 15 },
  { "name": "Compass", "price": 20 },
  { "name": "Protractor", "price": 10 },
  { "name": "Set Square", "price": 12 },
  { "name": "Chart Paper (Single)", "price": 10 },
  { "name": "Chart Paper (Pack of 10)", "price": 90 },
  { "name": "Sticky Notes", "price": 30 },
  { "name": "files", "price": 25 },
  { "name": "Glue Stick/ Fevik", "price": 20 },
  { "name": "Stapler", "price": 35 },
   { "name": "A4 papers", "price": 20 },
  { "name": "Legal papers", "price": 35 },
   { "name": "colors/ sketches", "price": 25 },
  { "name": "Water paintings", "price": 20 },
  { "name": "brushes", "price": 35 },
   { "name": "ball", "price": 20 },
  { "name": "bat", "price": 35 },
   { "name": "Toys", "price": 25 },
  { "name": "Remote control cars", "price": 20 },
  { "name": "Drone kinds", "price": 35 },
   { "name": "Matching cloths", "price": 20 },
  { "name": "Ribbons", "price": 35 },
   { "name": "Knives", "price": 25 },
  { "name": "Mirrors", "price": 20 },
  { "name": "nail cutter", "price": 35 },
   { "name": "Scissors", "price": 20 },
  { "name": "Blade packet", "price": 35 },
   { "name": "Tongue cleaner", "price": 25 },
  { "name": "Bangles", "price": 20 },
  { "name": "Gifts", "price": 35 },
   { "name": "Glass related items", "price": 20 },
  { "name": "color papers", "price": 35 },

],

    
                
                  "Cleaning_Supplies": [
                    { "name": "Dish Soap", "price": 40 },
                    { "name": "Detergent", "price": 60 },
                    { "name": "Floor Cleaner", "price": 50 },
                    { "name": "Glass Cleaner", "price": 45 },
                    { "name": "Bathroom Cleaner", "price": 70 },
                    { "name": "Toilet Cleaner", "price": 55 },
                    { "name": "Kitchen Cleaner", "price": 65 },
                    { "name": "Multipurpose Cleaner", "price": 60 },
                    { "name": "Bleach", "price": 30 },
                    { "name": "Disinfectant Spray", "price": 75 },
                    { "name": "Hand Sanitizer", "price": 25 },
                    { "name": "Laundry Sanitizer", "price": 80 },
                    { "name": "Fabric Softener", "price": 50 },
                    { "name": "Stain Remover", "price": 60 },
                    { "name": "Carpet Cleaner", "price": 90 },
                    { "name": "Upholstery Cleaner", "price": 85 },
                    { "name": "Air Freshener", "price": 45 },
                    { "name": "Odor Eliminator", "price": 55 },
                    { "name": "Mold and Mildew Cleaner", "price": 70 },
                    { "name": "Hardwood Floor Cleaner", "price": 80 },
                    { "name": "Tile Cleaner", "price": 65 },
                    { "name": "Grout Cleaner", "price": 75 },
                    { "name": "Stainless Steel Cleaner", "price": 90 },
                    { "name": "Oven Cleaner", "price": 85 },
                    { "name": "Drain Cleaner", "price": 60 },
                    { "name": "Septic Tank Treatment", "price": 100 },
                    { "name": "Garbage Disposal Cleaner", "price": 40 },
                    { "name": "Dusting Spray", "price": 35 },
                    { "name": "Wood Polish", "price": 55 },
                    { "name": "Metal Polish", "price": 65 },
                    { "name": "Leather Cleaner", "price": 75 },
                    { "name": "Rug Cleaner", "price": 85 },
                    { "name": "Window Cleaner", "price": 45 },
                    { "name": "Mirror Cleaner", "price": 40 },
                    { "name": "Shower Cleaner", "price": 70 },
                    { "name": "Tile and Grout Brush", "price": 25 },
                    { "name": "Scrub Brush", "price": 30 },
                    { "name": "Toilet Brush", "price": 35 },
                    { "name": "Bottle Brush", "price": 20 },
                    { "name": "Dustpan and Brush", "price": 50 },
                    { "name": "Mop and Bucket", "price": 70 },
                    { "name": "Vacuum Cleaner", "price": 300 },
                    { "name": "Steam Cleaner", "price": 400 },
                    { "name": "Carpet Sweeper", "price": 150 },
                    { "name": "Lint Roller", "price": 20 },
                    { "name": "Feather Duster", "price": 30 },
                    { "name": "Microfiber Cloth", "price": 15 },
                    { "name": "Sponges", "price": 10 },
                    { "name": "Cleaning Rags", "price": 20 },
                    { "name": "Scrub Pads", "price": 25 },
                    { "name": "Gloves", "price": 40 },
                    { "name": "Dust Mask", "price": 50 },
                    { "name": "Protective Eyewear", "price": 70 },
                    { "name": "Apron", "price": 30 },
                    { "name": "Broom", "price": 25 },
                    { "name": "Dustpan", "price": 20 },
                    { "name": "Squeegee", "price": 35 },
                    { "name": "Bucket", "price": 30 },
                    { "name": "Spray Bottle", "price": 15 },
                    { "name": "Refill Bottles", "price": 20 },
                    { "name": "Soap Dispenser", "price": 25 },
                    { "name": "Hand Soap", "price": 35 },
                    { "name": "Laundry Baskets", "price": 50 },
                    { "name": "Laundry Bags", "price": 30 },
                    { "name": "Drying Rack", "price": 100 },
                    { "name": "Clothespins", "price": 15 },
                    { "name": "Ironing Board", "price": 150 },
                    { "name": "Iron", "price": 200 },
                    { "name": "Fabric Steamer", "price": 250 },
                    { "name": "Starch Spray", "price": 25 },
                    { "name": "Lint Brush", "price": 20 },
                    { "name": "Pet Stain Cleaner", "price": 80 },
                    { "name": "Pet Odor Eliminator", "price": 60 },
                    { "name": "Pet Hair Remover", "price": 40 },
                    { "name": "Pet Shampoo", "price": 70 },
                    { "name": "Pet Grooming Gloves", "price": 50 },
                    { "name": "Pet Wipes", "price": 30 },
                    { "name": "Pet Deodorizer", "price": 40 },
                    { "name": "Litter Box Cleaner", "price": 60 },
                    { "name": "Aquarium Cleaner", "price": 50 },
                    { "name": "Car Cleaner", "price": 120 },
                    { "name": "Windshield Cleaner", "price": 90 },
                    { "name": "Car Wax", "price": 100 },
                    { "name": "Tire Cleaner", "price": 70 },
                    { "name": "Rim Cleaner", "price": 80 },
                    { "name": "Upholstery Brush", "price": 40 },
                    { "name": "Leather Conditioner", "price": 60 },


                    
  { "name": "Comfort", "price": 180 },
  { "name": "Rin", "price": 65 },
  { "name": "Surf Excel", "price": 90 },
  { "name": "Ariel", "price": 95 },
  { "name": "Tide", "price": 85 },
  { "name": "Ujala", "price": 55 },
  { "name": "Godrej Ezee", "price": 110 },
  { "name": "Genteel", "price": 100 },
  { "name": "Safewash", "price": 105 },
  { "name": "Henko", "price": 120 },
  { "name": "Presto!", "price": 130 },
  { "name": "Syclone", "price": 115 },
{ "name": "Pithambaram", "price": 25 },

                  ],
                
                
    
  });

  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  


  const [shopName, setShopName] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedItem, setSelectedItem] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useState([]);
  const [gstRate, setGstRate] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showModal, setShowModal] = useState(false);

  const [shareMethod, setShareMethod] = useState('');
  const [pdfFormat, setPdfFormat] = useState('default');


  const handleSearchChange = (event) => {
    const text = event.target.value;
    setSearchText(text);
  
    const allItems = Object.entries(categories).flatMap(([category, items]) =>
      items.map(item => ({ ...item, category }))
    );
  
    const filtered = allItems.filter(item =>
      item.name.toLowerCase().includes(text.toLowerCase())
    );
  
    setSuggestions(filtered);
  };

  const handleSelectSuggestion = (item) => {
    const newItem = {
      name: item.name,
      price: item.price,
      quantity: 1,
      subtotal: item.price * 1,
    };
    setCart([...cart, newItem]);
    setSearchText('');
    setSuggestions([]);
  };

  const handleNewBill = () => {
    setShopName('');
    setGstNumber('');
    setPhoneNumber('');
    setSelectedCategory('');
    setSelectedItem('');
    setQuantity(1);
    setCart([]);
    setGstRate(0);
    setSearchText('');
    setSuggestions([]);
    setPdfFormat('default');
  };
  

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedItem('');
    setQuantity(1);
  };

  const handleItemChange = (event) => {
    setSelectedItem(event.target.value);
    setQuantity(1);
  };

  const handleQuantityChange = (event) => {
    setQuantity(event.target.value);
  };

  const handleAddItem = () => {
    const categoryItems = categories[selectedCategory];
    const item = categoryItems.find(i => i.name === selectedItem);
    if (item) {
      const newItem = {
        name: item.name,
        price: item.price,
        quantity: quantity,
        subtotal: item.price * quantity
      };
      setCart([...cart, newItem]);
      setSelectedItem('');
      setQuantity(1);
    }
  };

  const handleGstRateChange = (event) => {
    setGstRate(event.target.value);
  };

  const handlePriceChange = (index, event) => {
    const newCart = [...cart];
    newCart[index].price = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleQuantityEdit = (index, event) => {
    const newCart = [...cart];
    newCart[index].quantity = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleRemoveItem = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1); // Remove one item at the given index
    setCart(newCart);
  };
  
  const calculateTotal = () => {
    const subtotal = cart.reduce((acc, item) => acc + item.subtotal, 0);
    const gst = subtotal * (gstRate / 100);
    const total = subtotal + gst;
    return { subtotal, gst, total };
  };

  const generatePdfInvoice = () => {
    const total = calculateTotal();
    const currentDate = new Date().toLocaleDateString();
    const doc = new jsPDF();

    switch (pdfFormat) {
        case 'default':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'table':
            doc.autoTable({
                head: [['Shop Name', 'GST No', 'Phone Number', 'Date']],
                body: [[shopName, gstNumber, phoneNumber, currentDate]],
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'blueBlack':
            doc.setTextColor(0, 0, 255);
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.setTextColor(0, 0, 0);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'professionalGrid':
            doc.setFontSize(18);
            doc.text(shopName, 10, 10);
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 10, 20);
            doc.text(`Date: ${currentDate}`, 10, 30);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                theme: 'grid',
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                theme: 'grid',
            });
            break;

        case 'compactSummary':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

            
                case 'classicTable':
                    doc.setFontSize(20);
                    doc.text(shopName, 105, 15, null, null, 'center');
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
                    doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
                    doc.setFontSize(16);
                    doc.text('Invoice', 105, 30, null, null, 'center');
                    doc.autoTable({
                        startY: 40,
                        head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                        body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                    });
                    break;
        
                case 'boxedLayout':
                    doc.setFontSize(20);
                    doc.text(shopName, 10, 10);
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 10, 20);
                    doc.text(`Date: ${currentDate}`, 10, 30);
                    doc.autoTable({
                        startY: 40,
                        head: [['Item', 'Price', 'Quantity', 'Subtotal']],
                        body: cart.map((item) => [item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                        styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0], lineWidth: 0.5 },
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                        styles: { fillColor: [0, 180, 0], textColor: [0, 0, 0] },
                    });
            break;   
            
            

        case 'modernMinimalist':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity(Kg/ltr/each', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            break;

        case 'elegantLines':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            break;

        case 'detailedSections':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Section', 'Details']],
                body: [
                    ['Shop Details', `${shopName}, GST No: ${gstNumber}, Date: ${currentDate}`],
                    ['Items', cart.map((item) => `Name: ${item.name}, Quantity: ${item.quantity}, Subtotal: ${item.subtotal.toFixed(2)}`).join('; ')],
                    ['Totals', `Subtotal: ${total.subtotal.toFixed(2)}, GST: ${total.gst.toFixed(2)}, Total: ${total.total.toFixed(2)}`],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.5 },
            });
            break;

        

        default:
            break;
    }

    // Save the PDF to Blob
    const pdfBlob = doc.output('blob');

    // Share to WhatsApp
    const shareToWhatsApp = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(whatsappUrl, '_blank');
    };

    // Share to Email
    const shareToEmail = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const mailtoUrl = `mailto:?subject=Your Invoice&body=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(mailtoUrl, '_blank');
    };

    // Share the PDF as needed
    if (shareMethod === 'whatsapp') {
        shareToWhatsApp();
    } else if (shareMethod === 'mail') {
        shareToEmail();
    }

    // Save the PDF
    //doc.save('invoice.pdf');
    doc.save(`${shopName +'-invoice' || 'invoice'}.pdf`);

};


  const handleShare = (method) => {
    setShareMethod(method); // Set the sharing method
    const shareText = `Shop Name: ${shopName}\nGST No: ${gstNumber}\nPhone Number: ${phoneNumber}`;

    if (method === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(shareText)}`);
    } else if (method === 'mail') {
      window.open(`mailto:?subject=MarketApp%20Details&body=${encodeURIComponent(shareText)}`);
    }

    setShowModal(false); // Close modal after sharing
  };

  const handleGenerateAndShare = () => {
    generatePdfInvoice();
    setShowModal(true); // Show modal after generating PDF
  };

  const handleFormatChange = (e) => {
    setPdfFormat(e.target.value); // Set the PDF format
};

const formatOptions = [
    { value: 'default', label: 'Default' },
    { value: 'table', label: 'Table Format' },
    { value: 'blueBlack', label: 'Blue and Black' },
    { value: 'professionalGrid', label: 'Professional Grid' },
    { value: 'compactSummary', label: 'Compact Summary' },
    { value: 'classicTable', label: 'Classic Table' },
    { value: 'boxedLayout', label: 'Boxed Layout' },
    { value: 'modernMinimalist', label: 'Modern Minimalist' },
    { value: 'elegantLines', label: 'Elegant Lines' },
    { value: 'detailedSections', label: 'Detailed Sections' },
    
];


return (
    <div className="MarketApp">
       <img src="./Images/jalm.png" alt="Just A Little Market" width="100" height="100" />
      <h1><u>Supermarket</u></h1>

<div style={{ marginTop: '20px', textAlign: 'left', paddingLeft: '10px' }}>
  <button
    onClick={handleNewBill}
    style={{
      backgroundColor: '#007bff',
      color: '#fff',
      padding: '12px 20px',
      fontSize: '18px',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 123, 255, 0.3)',
      transition: 'background-color 0.3s ease, transform 0.2s ease'
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = '#0056b3';
      e.target.style.transform = 'scale(1.05)';
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = '#007bff';
      e.target.style.transform = 'scale(1)';
    }}
  >
    🧾 New Bill
  </button>
</div>
<br/>

  
      {/* Shop Info */}
  
    <div className="container">
  {/* Responsive Input Section */}
  <div className="input-section">
    <div className="form-group">
      <label>Shop Name:</label>
      <input type="text" value={shopName} onChange={(e) => setShopName(e.target.value)} />
    </div>

    <div className="form-group">
      <label>GST No:</label>
      <input type="text" value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Phone Number:</label>
      <input type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Search Items:</label>
      <input
        type="text"
        value={searchText}
        onChange={handleSearchChange}
        placeholder="Type to search..."
      />
      {suggestions.length > 0 && (
        <ul className="suggestion-list">
          {suggestions.map((item, idx) => (
            <li key={idx} onClick={() => handleSelectSuggestion(item)}>
              {item.name} — ₹{item.price} <span className="category">({item.category})</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>

  {/* Category Selection */}
  <div className="form-group">
    <label>Select Category:</label>
    <select onChange={handleCategoryChange} value={selectedCategory}>
      <option value="" disabled>Select a category</option>
      {Object.keys(categories).map((cat, i) => (
        <option key={i} value={cat}>{cat}</option>
      ))}
    </select>
  </div>

  {selectedCategory && (
    <>
      <div className="form-group">
        <label>Select Item:</label>
        <select onChange={handleItemChange} value={selectedItem}>
          <option value="" disabled>Select an item</option>
          {categories[selectedCategory].map((item, i) => (
            <option key={i} value={item.name}>{item.name}</option>
          ))}
        </select>
      </div>

      {selectedItem && (
        <>
          <div className="form-group">
            <label>Quantity:</label>
            <input type="number" value={quantity} onChange={handleQuantityChange} min="1" />
          </div>
          <div className="form-group">
            <button onClick={handleAddItem}>Add Item</button>
          </div>
        </>
      )}
    </>
  )}

  {/* Cart Table */}
  <div className="cart-section">
    <h2>Cart</h2>
    {cart.length === 0 ? (
      <p>No items added.</p>
    ) : (
      <div className="responsive-table">
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Price</th>
              <th>Qty</th>
              <th>Subtotal</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>
                  <input
                    type="number"
                    value={item.price}
                    onChange={(e) => handlePriceChange(index, e)}
                    min="0"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={item.quantity}
                    onChange={(e) => handleQuantityEdit(index, e)}
                    min="1"
                  />
                </td>
                <td>{item.subtotal.toFixed(2)}</td>
                <td><button onClick={() => handleRemoveItem(index)}>Remove</button></td>
              </tr>
            ))}
            <tr>
              <td colSpan="3">Subtotal</td>
              <td>{calculateTotal().subtotal.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">
                GST Rate:
                <select onChange={handleGstRateChange} value={gstRate}>
                  <option value="0">0%</option>
                  <option value="5">5%</option>
                  <option value="6">6%</option>
                  <option value="9">9%</option>
                  <option value="18">18%</option>
                </select>
              </td>
              <td>{calculateTotal().gst.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">Total</td>
              <td>{calculateTotal().total.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )}
  </div>

  {/* PDF Section */}
{cart.length > 0 && (
 
  <div className="pdf-section" style={{
    marginTop: '30px',
    padding: '20px',
    backgroundColor: '#f1f3f5',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  }}>
    <label style={{
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333'
    }}>
      🧾 Select Invoice Format:
    </label>

    <select
      onChange={handleFormatChange}
      value={pdfFormat}
      style={{
        padding: '10px',
        fontSize: '16px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      {formatOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>

    <button
      onClick={handleGenerateAndShare}
      style={{
        backgroundColor: '#007bff',
        color: '#fff',
        padding: '14px',
        fontSize: '17px',
        fontWeight: '600',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0,123,255,0.3)',
        transition: 'transform 0.2s ease, background-color 0.3s ease'
      }}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = '#0056b3';
        e.target.style.transform = 'scale(1.05)';
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = '#007bff';
        e.target.style.transform = 'scale(1)';
      }}
    >
      📄 Generate PDF Invoice
    </button>
  </div>
)}


<br /><br />

 

</div>

 </div>   
  ); // ✅ this closes the return statement
  
  
}

export default SuperMarket;
  


  

